import { headerCellsProps } from './header-cells-props'
import { Entity } from './types'

const defaultCellsProps = {
  [Entity.Count]: headerCellsProps[Entity.Count],
  [Entity.Category]: headerCellsProps[Entity.Category],
  [Entity.Date]: headerCellsProps[Entity.Date],
  [Entity.Total]: headerCellsProps[Entity.Total],
}

export const createDataProps = () => {
  return new Proxy(defaultCellsProps, {
    get: function (target, property) {
      const res = target[property as string]
      if (!res) {
        return defaultCellsProps[Entity.Date]
      }
      return res || {}
    },
  })
}
